<template>
  <div class="membership_manage_width">
    <div class="pa-3 pl-10">
      <p class="display-1 mt-7">멤버십 설정/관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        쿠팡,네이버,G마켓,옥션등 기타 마켓에서 제공하는 멤버십 서비스와 같이
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        우리 쇼핑몰만의 멤버십을 만들어 회원들에게 제공할 수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정기결제의 경우 사용중인 PG사에 신청하여 사용이 가능합니다 . (올앳,
        이니시스, KCP, 토스페이먼츠 가능)
      </p>
    </div>
    <v-container class="pl-10">
      <v-tabs v-model="tab">
        <!--
            멤버십 혜택 설정 contents 영역
        -->
        <v-tab class="title" href="#tab-1">멤버십 혜택 설정</v-tab>
        <v-tab-item value="tab-1">
          <MembershipSetting @setDisabled="setDisabled"></MembershipSetting>
        </v-tab-item>

        <!--
           쇼핑몰 노출 부분 설정 contents 영역
        -->
        <v-tab
          class="title"
          @click="mallShowPartAlert()"
          href="#tab-1"
          style="color: rgba(0, 0, 0, 0.54);"
          >쇼핑몰 노출 부분</v-tab
        >
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
const MembershipSetting = () =>
  import(
    /* webpackChunkName: "MembershipSetting" */ "@/components/membership/membership_manage/MembershipSetting.vue"
  );
export default {
  data: () => ({
    disabled: true,
    membership_id: 0,
    tab: "tab-1",
  }),
  components: {
    MembershipSetting,
  },
  methods: {
    setDisabled: function(param) {
      this.disabled = false;
      this.membership_id = param.membership_id;

      if (
        confirm(
          "저장되었습니다.\n\n확인 버튼을 클릭하시면\n멤버십 상품페이지 설정 화면으로\n이동됩니다."
        )
      ) {
        this.$router.push({
          path: `/membership/${this.$store.state.mallId}/membershipReSetting?membership_id=${this.membership_id}&step=2`,
        });
      } else {
        this.$router.push({
          path: `/membership/${this.$store.state.mallId}/membershipReSetting?membership_id=${this.membership_id}&step=1`,
        });
      }
    },
    mallShowPartAlert: function() {
      this.tab = "tab-1";
      alert(
        "멤버십 혜택 설정을 먼저 해주셔야\n쇼핑몰 노출 부분 설정이 가능합니다."
      );
    },
  },
};
</script>
